export enum VulnerableCitizenEnum {
	NO_CRITERION = 1,
	OLD_PEOPLE_AND_CHILDREN = 2,
	CITIZENS_RECEIVING_SOCIAL_BENEFITS = 3,
	BOTH_CRITERIA = 4,
}
